import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {
  Form,
  Input,
  Checkbox,
  Button,
  Select,
  Tooltip,
  Switch,
  Radio,
  Modal
} from "antd";
import { getUsers, handlingDrawer } from "../../actions/UsersAction";
import { createGroup } from "../../actions/GroupAction";
import { RequiredField } from "../required-field/RequiredField";
import {
  sendNotification,
  mergeArrays,
  getWithDrawer,
  permissionTranslation
} from "../../utils";
// import CreateUsers from './CreateUsers'
import Tree from "./Tree";
import { fetchDirectChildFolders } from "../../actions/ClientAction";
import {
  isFolderPermission,
  isAssetPermission,
  isDartPermission
} from "../../utils/index";
import "./create.css";
import Invitation from "../users/Invitation";

const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const { Option } = Select;

export class Create extends Component {
  constructor(props) {
    super(props);

    this.listPermission = [...this.props.defaultPermissions.map(r => r.view)];
    this.assetPermissionList = this.props.defaultPermissions
      .filter(permission => isAssetPermission(permission.action))
      .map(r => r.view);
    this.folderPermissionList = this.props.defaultPermissions
      .filter(permission => isFolderPermission(permission.action))
      .map(r => r.view);
    this.dartPermissionList = this.props.defaultPermissions
      .filter(permission => isDartPermission(permission.action))
      .map(r => r.view);
    // this.hostPermissionsList = this.props.defaultPermissions.filter(permission => isHostPermission(permission.action)).map(r => r.view)
    this.state = {
      name: "",
      description: "",
      options: [],
      permission: [],
      indeterminate: false,
      checkAll: false,
      allFolders: [],
      folders: [],
      lastLevelObjects: [],
      allParents: [],
      usersSelectedEmail: [],
      usersSelectedId: [],
      objectsSelectedId: [],
      recieveEmails: true,
      checkedRadio: null,
      showNewUserDrawer: false,
      usersCreate: null,
      dataUsersCreate: [],
      allFoldersChecked: false,
      allFoldersCheckedBySwitch: false,
      assetPermissions: [],
      allAssetPermissionsChecked: false,
      folderPermissions: [],
      allFolderPermissionsChecked: false,
      dartPermissions: [],
      allDartPermissionsChecked: false,
      showInvitationUser: false
    };
  }

  componentDidMount() {
    const { workclient } = this.props;

    this.props.getUsers(workclient, 1, null, true);
    this.handleGetData();
  }

  componentDidUpdate(prevProps) {
    const { data, createStatus, newUser, user, rootFolders } = this.props;
    const { dataUsersCreate, usersCreate, options } = this.state;

    if (prevProps.rootFolders !== rootFolders) {
      this.handleGetData();
    }

    if (prevProps.data !== data && data.length > 0) {
      this.setState({
        options: data
          .filter(r => r._id !== user)
          .filter(r => !!r.status)
          .filter(r => !r.email.includes("@bunkey"))
          .map((r, k) => (
            <Option
              key={k}
              value={r.email + " " + r.name}
              uid={r._id}
            >{`${r.name} (${r.email})`}</Option>
          ))
      });
    }

    if (prevProps.newUser !== newUser && newUser) {
      this.setState({
        usersCreate: newUser
      });
    }

    if (usersCreate && options.find(r => r.props.uid === usersCreate._id)) {
      dataUsersCreate.push(options.find(r => r.props.uid === usersCreate._id));
      this.handleOnChangeUser(usersCreate.email, dataUsersCreate, true);
      this.setState({
        usersCreate: null
      });
    }

    if (createStatus !== prevProps.createStatus && createStatus === "success")
      this.props.handleClose();
  }

  handleOnChangeName = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onChangeAllAssetsPermissions = checked => {
    this.setState((state, props) => {
      const newPermssion = checked ? [...this.assetPermissionList] : [];
      return {
        assetPermissions: newPermssion,
        allAssetPermissionsChecked: checked
      };
    });
  };

  handleOnChangeAssetPermission = assetPermissions => {
    this.setState({
      assetPermissions,
      allAssetPermissionsChecked:
        assetPermissions.length === this.assetPermissionList.length
    });
  };

  onChangeAllFolderPermissions = checked => {
    this.setState((state, props) => {
      const newPermssion = checked ? [...this.folderPermissionList] : [];
      return {
        folderPermissions: newPermssion,
        allFolderPermissionsChecked: checked
      };
    });
  };

  handleOnChangeFolderPermission = folderPermissions => {
    this.setState({
      folderPermissions,
      allFolderPermissionsChecked:
        folderPermissions.length === this.folderPermissionList.length
    });
  };

  onChangeAllDartPermissions = checked => {
    this.setState((state, props) => {
      const newPermssion = checked ? [...this.dartPermissionList] : [];
      return {
        dartPermissions: newPermssion,
        allDartPermissionsChecked: checked
      };
    });
  };

  handleOnChangeDartPermission = dartPermissions => {
    this.setState({
      dartPermissions: dartPermissions,
      allDartPermissionsChecked:
        dartPermissions.length === this.dartPermissionList.length
    });
  };

  handleOnChangeUser = (item, list, isCreating = null) => {
    const { usersSelectedEmail, usersSelectedId } = this.state;
    let emails = usersSelectedEmail;
    let ids = usersSelectedId;
    //
    if (isCreating) {
      emails.push(item);
      ids.push(list[list.length - 1].props.uid);
    }
    //
    this.setState({
      usersSelectedEmail: isCreating ? emails : item,
      usersSelectedId: isCreating ? ids : list.map(r => r.props.uid)
    });
    //
  };

  onChangeFolder = (ids, names, list) => {
    const { allParents } = this.state;
    const parent = list.triggerNode.props.allParents
      .filter(r => r.type !== "root")
      .map(r => r._id);
    const mixParents = mergeArrays(allParents, parent);
    const result = mergeArrays(ids, mixParents);
    const lastLevelObjects = result.filter(r => {
      const exists = mixParents.find(f => f === r);
      return exists ? null : r;
    });
    this.setState({
      objectsSelectedId: ids,
      folders: result,
      lastLevelObjects,
      allParents: mixParents
    });
  };

  handleGetData = async () => {
    const { rootFolders } = this.props;
    if (rootFolders) {
      this.setState({ allFolders: rootFolders.map(r => this.folderToTreeNode(r)) });
    }
  };

  folderToTreeNode = (r, parentAllParents = null) => {
    const allParents = parentAllParents
      ? parentAllParents
      : r.parents || [];
    return {
      rawName: r.name,
      title:
        r.name.length > 50 ? (
          <Tooltip title={r.name} placement="left">
            {r.name.slice(0, 50)}...
          </Tooltip>
        ) : (
          r.name
        ),
      value: r._id,
      key: r._id,
      parent: allParents.slice(-1)[0] || null,
      allParents,
      allChilds: [],
      hasChildren: r.hasChildren || false,
      children: [],
    };
  };

  handleLoadChildren = async (parentItem) => {
    const { workclient } = this.props;
    const children = await fetchDirectChildFolders(workclient, parentItem.key);
    const parentAllParents = [
      ...parentItem.allParents,
      { _id: parentItem.key, name: parentItem.rawName, type: "folder" },
    ];
    return children.map(r => this.folderToTreeNode(r, parentAllParents));
  };

  handleOnChageAllFolders = value => {
    this.setState({
      allFoldersChecked: value,
      allFoldersCheckedBySwitch: true
    });
  };

  handleOnChageAllUsers = value => {
    const { data, user } = this.props;
    const dataFilter = data
      .filter(r => r._id !== user)
      .filter(r => !!r.status)
      .filter(r => !r.email.includes("@bunkey"));
    const operators = dataFilter.filter(r => r._id !== user);

    this.setState({
      usersSelectedEmail: value ? operators.map(r => r.email) : [],
      usersSelectedId: value ? dataFilter.map(r => r._id) : []
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { workclient, intl } = this.props;
    const {
      name,
      description,
      usersSelectedId,
      folders,
      lastLevelObjects,
      objectsSelectedId,
      recieveEmails,
      showNewUserDrawer,
      assetPermissions,
      folderPermissions,
      dartPermissions
    } = this.state;

    const mergedPermissions = [
      ...assetPermissions,
      ...folderPermissions,
      ...dartPermissions
    ];

    if (!name && !showNewUserDrawer) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "must_enter_group_name" })
      );
    } else if (!description && !showNewUserDrawer) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "must_enter_purpose" })
      );
    } else if (usersSelectedId.length === 0 && !showNewUserDrawer) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "must_select_user" })
      );
    } else {
      let permissions = this.props.defaultPermissions.map(r => {
        const exists = mergedPermissions.find(item => item === r.view);
        return {
          action: r.action,
          enabled: exists ? true : false
        };
      });
      if (recieveEmails && !showNewUserDrawer) {
        this.props.createGroup(
          name,
          description,
          workclient,
          usersSelectedId,
          folders,
          permissions,
          lastLevelObjects,
          objectsSelectedId,
          true,
          intl
        );
      } else {
        if (!showNewUserDrawer) {
          this.props.createGroup(
            name,
            description,
            workclient,
            usersSelectedId,
            folders,
            permissions,
            lastLevelObjects,
            objectsSelectedId,
            false,
            intl
          );
        }
      }
    }
  };

  handleRecieveMails = e => {
    this.setState({
      recieveEmails: e.target.value === 1 ? true : false
    });
  };

  handleShowNewUserDrawer = () => {
    this.setState(
      {
        showNewUserDrawer: true
      },
      () => this.props.handlingDrawer(true)
    );
  };

  handleHideNewUserDrawer = () => {
    this.setState(
      {
        showNewUserDrawer: false
      },
      () => this.props.handlingDrawer(false)
    );
  };

  handleSelectedFolders = objectsId => {
    const { allFolders } = this.state;
    const allFoldersLength =
      allFolders.length +
      allFolders.reduce((acum, folder) => {
        return acum + folder.allChilds.length;
      }, 0);

    this.setState({
      folders: objectsId,
      lastLevelObjects: objectsId,
      objectsSelectedId: objectsId,
      allFoldersChecked: allFoldersLength === objectsId.length,
      allFoldersCheckedBySwitch: false
    });
  };

  handleHideInvitationUser = () => {
    this.setState({
      showInvitationUser: false
    });
  };

  handleShowInvitationUser = () => {
    this.setState({
      showInvitationUser: true
    });
  };

  render() {
    const { newColor, isCreating, intl } = this.props;
    const {
      name,
      description,
      options,
      allFolders,
      usersSelectedEmail,
      // showNewUserDrawer,
      allFoldersChecked,
      allFoldersCheckedBySwitch,
      assetPermissions,
      allAssetPermissionsChecked,
      folderPermissions,
      allFolderPermissionsChecked,
      dartPermissions,
      allDartPermissionsChecked,
      showInvitationUser
    } = this.state;

    return (
      <Form layout="vertical" onSubmit={this.handleSubmit}>
        <Form.Item>
          <RequiredField name={intl.formatMessage({ id: "group_name" })} />
          <Input
            name="name"
            value={name}
            placeholder={intl.formatMessage({ id: "put_name_recognize" })}
            onChange={this.handleOnChangeName}
          />
        </Form.Item>
        <Form.Item>
          <RequiredField
            name={intl.formatMessage({ id: "describe_purpose_group" })}
          />
          <TextArea
            row={4}
            name="description"
            value={description}
            placeholder={intl.formatMessage({ id: "say_in_nutshell" })}
            onChange={this.handleOnChangeName}
          />
        </Form.Item>
        <Form.Item label={intl.formatMessage({ id: "group_users" })}>
          <span>
            {intl.formatMessage({ id: "select_all" })}:
            <span className="space-switch">
              <Switch
                checkedChildren={intl.formatMessage({ id: "yes" })}
                onChange={this.handleOnChageAllUsers}
                unCheckedChildren={intl.formatMessage({ id: "no" })}
                defaultChecked={false}
              />
            </span>
          </span>
          {/* <Button
            style={{ marginLeft: '10px' }}
            size="small"
            onClick={this.handleShowNewUserDrawer}
          >{intl.formatMessage({ id: "new_user" })}</Button> */}
          <Button
            style={{ marginLeft: "10px" }}
            size="small"
            onClick={this.handleShowInvitationUser}
          >
            {intl.formatMessage({ id: "send_invitation" })}
          </Button>

          <Select
            mode="multiple"
            placeholder={intl.formatMessage({ id: "choose_this_list" })}
            value={usersSelectedEmail}
            onChange={this.handleOnChangeUser}
            style={{ width: "100%" }}
          >
            {options}
          </Select>
        </Form.Item>
        <Form.Item>
          <label style={{ color: "rgba(0, 0, 0, 0.85)" }}>
            {intl.formatMessage({ id: "define_the_permissions" })}
          </label>
          <div style={{ top: "-8px", position: "relative" }}>
            <span style={{ color: "#bfbfbf" }}>
              {intl.formatMessage({ id: "what_users_group" })}
            </span>
          </div>

          <div
            style={{
              borderBottom: "1px solid #E9E9E9",
              marginBottom: 10,
              paddingBottom: 10,
              marginTop: 10
            }}
          >
            <div className="title-bar" style={{ marginLeft: "0px" }}>
              <span>{intl.formatMessage({ id: "assets_title" })}</span>
            </div>
            <div>
              <span>
                {intl.formatMessage({ id: "select_all" })}:
                <span className="space-switch">
                  <Switch
                    checkedChildren={intl.formatMessage({ id: "yes" })}
                    onChange={this.onChangeAllAssetsPermissions}
                    unCheckedChildren={intl.formatMessage({ id: "no" })}
                    checked={allAssetPermissionsChecked}
                  />
                </span>
              </span>
            </div>
            <div className="group-create">
              <CheckboxGroup
                options={this.assetPermissionList}
                value={assetPermissions}
                onChange={this.handleOnChangeAssetPermission}
              />
            </div>
          </div>

          <div
            style={{
              borderBottom: "1px solid #E9E9E9",
              marginBottom: 10,
              paddingBottom: 10,
              marginTop: 10
            }}
          >
            <div className="title-bar" style={{ marginLeft: "0px" }}>
              <span>{intl.formatMessage({ id: "folders" })}</span>
            </div>
            <div>
              <span>
                {intl.formatMessage({ id: "select_all" })}:
                <span className="space-switch">
                  <Switch
                    checkedChildren={intl.formatMessage({ id: "yes" })}
                    onChange={this.onChangeAllFolderPermissions}
                    unCheckedChildren={intl.formatMessage({ id: "no" })}
                    checked={allFolderPermissionsChecked}
                  />
                </span>
              </span>
            </div>
            <div className="group-create">
              <CheckboxGroup
                options={this.folderPermissionList}
                value={folderPermissions}
                onChange={this.handleOnChangeFolderPermission}
              />
            </div>
          </div>
          <div
            style={{
              borderBottom: "1px solid #E9E9E9",
              marginBottom: 10,
              paddingBottom: 10,
              marginTop: 10
            }}
          >
            <div className="title-bar" style={{ marginLeft: "0px" }}>
              <span>{intl.formatMessage({ id: "comments_title" })}</span>
            </div>
            <div>
              <span>
                {intl.formatMessage({ id: "select_all" })}:
                <span className="space-switch">
                  <Switch
                    checkedChildren={intl.formatMessage({ id: "yes" })}
                    onChange={this.onChangeAllDartPermissions}
                    unCheckedChildren={intl.formatMessage({ id: "no" })}
                    checked={allDartPermissionsChecked}
                  />
                </span>
              </span>
            </div>
            <div className="group-create">
              <CheckboxGroup
                options={this.dartPermissionList}
                value={dartPermissions}
                onChange={this.handleOnChangeDartPermission}
              />
            </div>
          </div>
        </Form.Item>
        <Form.Item>
          <label style={{ color: "rgba(0, 0, 0, 0.85)" }}>
            {intl.formatMessage({ id: "group_folder" })}
          </label>
          <div style={{ top: "-8px", position: "relative" }}>
            <span style={{ color: "#bfbfbf" }}>
              {intl.formatMessage({ id: "choose_bunker" })}
            </span>
          </div>
          <div>
            <span>
              {intl.formatMessage({ id: "select_all" })}:
              <span className="space-switch">
                <Switch
                  checkedChildren={intl.formatMessage({ id: "yes" })}
                  onChange={this.handleOnChageAllFolders}
                  unCheckedChildren={intl.formatMessage({ id: "no" })}
                  checked={this.state.allFoldersChecked}
                />
              </span>
            </span>
          </div>
          <Tree
            data={allFolders}
            allFoldersChecked={allFoldersChecked}
            allFoldersCheckedBySwitch={allFoldersCheckedBySwitch}
            handleSelectedFolders={this.handleSelectedFolders}
            onLoadChildren={this.handleLoadChildren}
          />
          {/* <TreeSelect
            dropdownStyle={{ width: 300, maxHeight: 400 }}
            treeData={allFolders}
            onChange={this.onChangeFolder}
            value={objectsSelectedId}
            treeCheckable={true}
            showCheckedStrategy={SHOW_ALL}
            searchPlaceholder={intl.formatMessage({ id: "choose_this_list" })}
          /> */}
        </Form.Item>
        <Form.Item>
          <span>{intl.formatMessage({ id: "recieve_email" })}</span>
          <Radio.Group onChange={this.handleRecieveMails} defaultValue={1}>
            <Radio style={{ marginLeft: "15px" }} value={1}>
              {intl.formatMessage({ id: "yes" })}
            </Radio>
            <Radio value={2}>No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              loading={isCreating}
              htmlType="submit"
              type="primary"
              style={{
                backgroundColor: newColor,
                borderColor: newColor,
                marginBottom: 5
              }}
            >
              {intl.formatMessage({ id: "create" })}
            </Button>
            <Button
              type="default"
              onClick={this.props.handleClose}
              style={{
                backgroundColor: newColor,
                borderColor: newColor,
                color: "#fff",
                marginBottom: 5,
                marginLeft: 5
              }}
            >
              {intl.formatMessage({ id: "cancel_button" })}
            </Button>
          </div>
        </Form.Item>
        {/* <Drawer
          title={intl.formatMessage({ id: "new_user" })}
          closable={true}
          width={getWithDrawer()}
          destroyOnClose={true}
          onClose={this.handleHideNewUserDrawer}
          visible={showNewUserDrawer}>
          <CreateUsers
            handleHideNewUserDrawer={this.handleHideNewUserDrawer}
          />
        </Drawer> */}
        <Modal
          title={intl.formatMessage({ id: "send_invitation" })}
          width={getWithDrawer()}
          closable={true}
          footer={null}
          onCancel={this.handleHideInvitationUser}
          onClose={this.handleHideInvitationUser}
          visible={showInvitationUser}
        >
          {showInvitationUser && (
            <Invitation
              showGroup={false}
              handleHideinvitationUser={this.handleHideInvitationUser}
            />
          )}
        </Modal>
      </Form>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    user: state.authUser.user._id,
    workclient: state.client.workclient,
    root: state.client.root,
    data: state.users.data,
    isCreating: state.group.isCreating,
    createStatus: state.group.createStatus,
    rootFolders: state.client.rootFolders,
    isFetching: state.users.isFetching,
    drawerdEnable: state.users.drawerdEnable,
    newUser: state.users.newUser,
    userExist: state.users.userExist,
    userAddStatus: state.users.userAddStatus,
    defaultPermissions: state.group.defaultPermissions.map(p => {
      return { ...p, view: permissionTranslation(p.action, ownProps.intl) };
    })
  };
};

const mapDispatchToProps = {
  getUsers,
  createGroup,
  handlingDrawer
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Create))
);
